import { render, staticRenderFns } from "./cardTemplateVip17.vue?vue&type=template&id=dcd60ba4&scoped=true&"
import script from "./cardTemplateVip17.vue?vue&type=script&lang=js&"
export * from "./cardTemplateVip17.vue?vue&type=script&lang=js&"
import style0 from "./cardTemplateVip17.vue?vue&type=style&index=0&id=dcd60ba4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcd60ba4",
  null
  
)

export default component.exports